module.exports = __webpack_public_path__ + "img/gys_13@2x.944ecd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_13@2x.png
// module id = abGV
// module chunks = 0